export const defaultNumberLineValue = () => {
    return {
        show : false,
        canvas_width : 500,
        canvas_height : 200,
        x_margin : 3,
        start_num : 1,
        end_num : 5,
        step : 1,
        stroke_weight : 1,
        text_size : 18,
        line_color : '#000',
        text_color : '#000',
        inputs : [],
        arrows : [],
        numbers : [],
        input_width : 40,
        input_height : 30,
        input_border_weight : 1,
        input_border_color : '#000',
        text_top_margin : 45,
        input_top_margin : 30,
        allow_select : false,
    }
}